import React, { useState } from "react";

import numberWithCommas from "../common/number";
import { Button } from "reactstrap";
import Modaltruckover from "../wms/modaltruckover";
import Modalcommenttruckover from "../wms/modalcommenttruckover ";
const Rendertruckover = ({ list, lastBookElementRef, onProgress }) => {
  const [detaillist, setdetaillist] = useState([]);
  const [commentlist, setcommentlist] = useState([]);
  const [askConfirm, setaskConfirm] = useState(false);
  const [isOpenCommentlist, setisOpenCommentlist] = useState(false);
  
  const handleCancleSubmit = () => {
    setaskConfirm(false);
  };
  const handleCanclemodalcomment = () => {
    setisOpenCommentlist(false);
  };

  const handelClickmodalcomment = (event) => {
    const found = list.find((item) => item.DeliveryID === event);
    if (found) {
      setcommentlist([found]);
      setisOpenCommentlist(true);
    }
  };
  const handelClick = (event) => {
    const found = list.find((item) => item.DeliveryID === event);
    if (found) {
      setdetaillist([found]);
      setaskConfirm(true);
    }
  };
  const handleChangeonProgress = (event) => {
    onProgress(event);
  };
  return (
    <>
      <Modaltruckover
        isOpen={askConfirm}
        onCancel={handleCancleSubmit}
        list={detaillist}
        onProgress={handleChangeonProgress}
      />
      <Modalcommenttruckover
        isOpen={isOpenCommentlist}
        onCancel={handleCanclemodalcomment}
        list={commentlist}
      />
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div  key={item.DeliveryID}>
              <div className="card  m-2">
                <div className="row m-1">
                  <div className=" col-xs-6 col-sm-4 col-md-2 lg-1 ">
                    <div style={{ fontSize: "18px" }}>
                      <span className="badge rounded-pill bg-secondary">
                        {item.no}
                      </span>
                    </div>
                    <div
                      className="badge badge-pill"
                      style={{ fontSize: "14px" }}
                    >
                      {item.weight_no}
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {item.Customer_Name}
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {item.customertypename}
                    </div>
                  </div>
             
                  <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          ใบนำส่ง:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.Delivery_No}
                          </small>{" "}
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วัตถุประสงค์:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.aim_name}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          กลุ่มสินค้า:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.type_name}
                          </small>
                        </h6>
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สินค้า:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.ProductName}
                          </small>
                        </h6>
                      </div>
                      <div></div>
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          รถ:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.truck_typename}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหัว:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.First_Driven_No +
                              " " +
                              item.FirstProvinceCode}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหาง:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.Second_driven_no + " " + item.ProvinceCode}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {item.commentlist.length > 0 ? (
                          <span
                            className="badge bg-success"
                            style={{ fontSize: "14px", cursor: "pointer" }}
                            onClick={() =>
                              handelClickmodalcomment(item.DeliveryID)
                            }
                          >
                            {item.commentlist.length}
                          </span>
                        ) : (
                          <span
                            style={{
                              fontSize: "13px",
                              backgroundColor: item.hexcolor,
                            }}
                            className="badge badge text-dark"
          
                          >
                            {"กรุณาระบุสาเหตุ"}
                          </span>
                        )}
                        <span className="badge badge text-dark"
          >
                          {" "}
                          {item.commentlist && item.commentlist.length > 0 && (
                            <span
                              style={{ fontSize: "14px", cursor: "pointer" }}
                            >
                              {
                                item.commentlist[item.commentlist.length - 1]
                                  .comment
                              }
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div>
                        <h6>
                          {" "}
                          นน.เข้า:
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge badge-pill">
                              {numberWithCommas(item.receive_weightin)}
                            </span>
                          </small>
                        </h6>
                      </div>
                      <div>
                        <h6>
                          {" "}
                          นน.ออก:
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge badge-pill">
                              {numberWithCommas(item.receive_weightout)}
                            </span>
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          นน.สุทธิ:
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge badge-pill">
                              {numberWithCommas(item.receive_weightnet)}
                            </span>
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          รถรอ(นาที):
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            <span
                              style={{
                                fontSize: "14px",
                                backgroundColor: item.hexcolor,
                              }}
                              className="badge badge text-dark"
          
                            >
                              {item.TimeDiff}
                            </span>
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "13px" }}>
                        <h6>
                          {" "}
                          เวลาเข้า:
                          <small style={{ fontSize: "13px" }}>
                            {" "}
                            {item.receive_datein}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "13px" }}>
                        <h6>
                          {" "}
                          เวลาออก:
                          <small style={{ fontSize: "13px" }}>
                            {" "}
                            {item.receive_dateout}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ที่ลง:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.store_name}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สถานะ:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.status_receive === "CheckOut" && (
                              <span
                                style={{ fontSize: "14px" }}
                                className="badge rounded-pill bg-info text-dark"
                              >
                                {item.status_receive}
                              </span>
                            )}
                            {item.status_receive === "CheckIn" && (
                              <span
                                style={{ fontSize: "14px" }}
                                className="badge rounded-pill bg-success"
                              >
                                {item.status_receive}
                              </span>
                            )}
                          </small>
                        </h6>
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1 d-flex justify-content-end d-flex align-items-center ">
                     
                      <Button
                      type="button"
                      onClick={() => handelClick(item.DeliveryID)}
                      className="btn btn-primary btn-sm "
                      color="primary"
                    >
                      บันทึกข้อมูล
                    </Button>
                     
                   
                    </div>
                </div>
              </div>
            </div>
            );
          } else {
            return (
              <div  key={item.DeliveryID}>
                <div className="card  m-2">
                  <div className="row m-1">
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1 ">
                      <div style={{ fontSize: "18px" }}>
                        <span className="badge rounded-pill bg-secondary">
                          {item.no}
                        </span>
                      </div>
                      <div
                        className="badge badge-pill"
                        style={{ fontSize: "14px" }}
                      >
                        {item.weight_no}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {item.Customer_Name}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {item.customertypename}
                      </div>
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          ใบนำส่ง:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.Delivery_No}
                          </small>{" "}
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วัตถุประสงค์:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.aim_name}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          กลุ่มสินค้า:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.type_name}
                          </small>
                        </h6>
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สินค้า:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.ProductName}
                          </small>
                        </h6>
                      </div>
                      <div></div>
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          รถ:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.truck_typename}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหัว:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.First_Driven_No +
                              " " +
                              item.FirstProvinceCode}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหาง:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.Second_driven_no + " " + item.ProvinceCode}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {item.commentlist.length > 0 ? (
                          <span
                            className="badge bg-success"
                            style={{ fontSize: "14px", cursor: "pointer" }}
                            onClick={() =>
                              handelClickmodalcomment(item.DeliveryID)
                            }
                          >
                            {item.commentlist.length}
                          </span>
                        ) : (
                          <span
                            style={{
                              fontSize: "13px",
                              backgroundColor: item.hexcolor,
                            }}
                            className="badge badge text-dark"
          
                          >
                            {"กรุณาระบุสาเหตุ"}
                          </span>
                        )}
                        <span className="badge badge text-dark"
          >
                          {" "}
                          {item.commentlist && item.commentlist.length > 0 && (
                            <span
                              style={{ fontSize: "14px", cursor: "pointer" }}
                            >
                              {
                                item.commentlist[item.commentlist.length - 1]
                                  .comment
                              }
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div>
                        <h6>
                          {" "}
                          นน.เข้า:
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge badge-pill">
                              {numberWithCommas(item.receive_weightin)}
                            </span>
                          </small>
                        </h6>
                      </div>
                      <div>
                        <h6>
                          {" "}
                          นน.ออก:
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge badge-pill">
                              {numberWithCommas(item.receive_weightout)}
                            </span>
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          นน.สุทธิ:
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge badge-pill">
                              {numberWithCommas(item.receive_weightnet)}
                            </span>
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          รถรอ(นาที):
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            <span
                              style={{
                                fontSize: "14px",
                                backgroundColor: item.hexcolor,
                              }}
                              className="badge badge text-dark"
          
                            >
                              {item.TimeDiff}
                            </span>
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "13px" }}>
                        <h6>
                          {" "}
                          เวลาเข้า:
                          <small style={{ fontSize: "13px" }}>
                            {" "}
                            {item.receive_datein}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "13px" }}>
                        <h6>
                          {" "}
                          เวลาออก:
                          <small style={{ fontSize: "13px" }}>
                            {" "}
                            {item.receive_dateout}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ที่ลง:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.store_name}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สถานะ:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.status_receive == "CheckOut" && (
                              <span
                                style={{ fontSize: "14px" }}
                                className="badge rounded-pill bg-info text-dark"
                              >
                                {item.status_receive}
                              </span>
                            )}
                            {item.status_receive == "CheckIn" && (
                              <span
                                style={{ fontSize: "14px" }}
                                className="badge rounded-pill bg-success"
                              >
                                {item.status_receive}
                              </span>
                            )}
                          </small>
                        </h6>
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1 d-flex align-items-center d-flex justify-content-end">
                 
                    <Button
                      type="button"
                      onClick={() => handelClick(item.DeliveryID)}
                      className="btn btn-primary btn-sm m-2"
                      color="primary"
                    >
                      บันทึกข้อมูล
                    </Button>
                   
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default Rendertruckover;
